import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { User } from '../models/user.model';
import { AuthService } from '../service/auth.service';
import { CrudService } from '../service/crud.service';
import { SharedService } from '../service/shared.service';
declare var $: any;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit, OnDestroy {

  constructor(private _router: Router, private authService: AuthService,
    private sharedService: SharedService, private crudservice: CrudService, private cdr: ChangeDetectorRef, private route: ActivatedRoute) { }

  user: User = new User();
  message: string;
  mType: string;
  userId: any = null;
  userRole: any = null;
  btnName: string = "Sign In";
  btnGetOtp: string = "Get OTP";
  loginMode: string = 'tcpl';
  currentYear: number = new Date().getFullYear();

  isTextFieldType: boolean = false;

  otp: any;
  otp0: any;
  otp1: any;
  otp2: any;
  otp3: any;
  otp4: any;
  otp5: any;

  showVerify: boolean = true;

  get isSubmitting(): boolean {
    return this.btnName === 'please wait...';
  }

  get isOtpSubmitting(): boolean {
    return this.btnGetOtp === 'please wait...';
  }

  ngOnInit() {
    document.documentElement.classList.add('login-page-active');
    document.body.classList.add('login-page-active');

    // Intranet SSO lands on /?t=token — login page used to ignore it and show Sign In.
    const ssoToken = this.route.snapshot.queryParamMap.get('t');
    if (ssoToken) {
      this.authService.markSessionActive();
      this._router.navigate(['/dashboard'], {
        queryParams: { t: ssoToken },
        replaceUrl: true
      });
      return;
    }

    // Same browser tab already has a TeamWorks session — skip login form.
    const userId = sessionStorage.getItem('userId');
    const fullName = sessionStorage.getItem('FullName');
    if (userId && fullName && userId !== 'null' && fullName !== 'null') {
      this.authService.markSessionActive();
      this._router.navigate(['/dashboard']);
      return;
    }

    sessionStorage.setItem('LoginFlag', '0');
  }

  ngOnDestroy() {
    document.documentElement.classList.remove('login-page-active');
    document.body.classList.remove('login-page-active');
  }

  setLoginMode(mode: string) {
    this.loginMode = mode;
    this.message = null;
    if (mode === 'thr') {
      this.showVerify = true;
    }
  }

  login() {
    this.message = null;

    if (this.user.Username == null || this.user.Username == '') {
      this.message = "Enter the TMC No.";
    }
    else if (this.user.Password == null || this.user.Password == '') {
      this.message = "Enter the Domain Password.";
    }

    if (this.message != null) {
      this.mType = 'error';
      return;
    }
    this.btnName = "please wait...";
    let formdata = new FormData();
    formdata.append("uname", this.user.Username);
    formdata.append("pass", this.user.Password);
    this.authService.userLogin(formdata).subscribe(
      udata => {
        console.log(udata)
        if (udata.Status) {
          this.btnName = "Sign In";
          var userResult = udata.Data;

          sessionStorage.setItem('userId', userResult.TMC);
          localStorage.setItem('userId', userResult.TMC);
          sessionStorage.setItem('FullName', userResult.Full_Name);
          sessionStorage.setItem('ReportingHeadId', userResult.Reporting_Head_ID);
          sessionStorage.setItem('ReportingManagerName', userResult.Reporting_Head_Name);
          sessionStorage.setItem('ReportingManagerEmail', userResult.Reporting_Head_Email);
          sessionStorage.setItem('UserEmail', userResult.Company_E_Mail);
          sessionStorage.setItem('UserDesignation', userResult.Designation);
          sessionStorage.setItem('UserDepartment', userResult.Department);
          sessionStorage.setItem('UserSBU', userResult.EmployeeSBU);
          sessionStorage.setItem('UserSUBBU', userResult.SUBBU_Code);
          sessionStorage.setItem('UserSBUCode', userResult.SBUCode);
          sessionStorage.setItem('UserBranch', userResult.Branch);
          sessionStorage.setItem('UserLocation', userResult.Location_Code);
          sessionStorage.setItem('IsHrAdmin', userResult.HR_Admin);
          sessionStorage.setItem('DOJ', userResult.Date_of_Joining);
          sessionStorage.setItem('Band', userResult.Employee_Band);
          sessionStorage.setItem('phoneNo', userResult.Mobile_Phone_No);
          sessionStorage.setItem('Birth_Date', userResult.Birth_Date);
          sessionStorage.setItem('functionalAreaName', userResult.functionalAreaName);
          sessionStorage.setItem('TMC', userResult.TMC);
          sessionStorage.setItem('companyId', userResult.companyId);
          console.log('companyId', userResult.companyId);
          this.sharedService.setItem('userdata', udata.Data);
          sessionStorage.setItem('CompanyName', userResult.CompanyName);
          sessionStorage.setItem('IsReEmployee', userResult.IsReEmployee);
          // Tara BU HR flag — also seed rolesFlags so New Joining List sees hasBUHR immediately
          const isBuhrFlag = userResult.ISBUHR === 1 || userResult.ISBUHR === '1' || userResult.ISBUHR === true;
          sessionStorage.setItem('ISBUHR', isBuhrFlag ? '1' : '0');
          const hasHr = (userResult.UserRole || []).some((x: any) => x.ACCESS_ROLE === 'HRPROFILE' && x.ACTIVE !== false);
          const hasBuhrRole = (userResult.UserRole || []).some((x: any) =>
            x.ACTIVE !== false && (x.ACCESS_ROLE === 'BUHR' || x.ACCESS_ROLE === 'BHR' || x.ACCESS_ROLE === 'BU HR'));
          sessionStorage.setItem('rolesFlags', JSON.stringify({
            hasHRProfile: hasHr,
            hasBUHR: isBuhrFlag || hasBuhrRole
          }));

          if (userResult.UserRole.filter(x => x.ACCESS_ROLE == 'HRPROFILE').length > 0) {
            sessionStorage.setItem('UserHRRole', userResult.UserRole.filter(x => x.ACCESS_ROLE == this.sharedService.UserRoleHR)[0].ACCESS_ROLE);
            //sessionStorage.setItem('IsHrAdmin', 'true');
          }
          else {
            sessionStorage.setItem('UserHRRole', '');
          }
          if (userResult.UserRole.filter(x => x.ACCESS_ROLE == 'ACCOUNTS').length > 0) {
            sessionStorage.setItem('UserAccountsRole', userResult.UserRole.filter(x => x.ACCESS_ROLE == this.sharedService.UserRoleAccounts)[0].ACCESS_ROLE);
          }
          else {
            sessionStorage.setItem('UserAccountsRole', '');
          }
          if (userResult.UserRole.filter(x => x.ACCESS_ROLE == 'BUHEAD').length > 0) {
            sessionStorage.setItem('UserRoleBUHead', userResult.UserRole.filter(x => x.ACCESS_ROLE == this.sharedService.UserRoleBUHead)[0].ACCESS_ROLE);
          }
          else {
            sessionStorage.setItem('UserRoleBUHead', '');
          }
          if (userResult.UserRole.filter(x => x.ACCESS_ROLE == 'TRAVELDESK').length > 0) {
            sessionStorage.setItem('UserTravelDesk', userResult.UserRole.filter(x => x.ACCESS_ROLE == this.sharedService.UserTravelDesk)[0].ACCESS_ROLE);
          }
          else {
            sessionStorage.setItem('UserTravelDesk', '');
          }

          if (userResult.UserRole.filter(x => x.ACCESS_ROLE == 'FINANCE').length > 0) {
            sessionStorage.setItem('UserFinanceRole', userResult.UserRole.filter(x => x.ACCESS_ROLE == this.sharedService.UserRoleFinance)[0].ACCESS_ROLE);

          }
          else {
            sessionStorage.setItem('UserFinanceRole', '');
          }

          if (userResult.UserRole.filter(x => x.ACCESS_ROLE == 'KOCKPIT').length > 0) {
            sessionStorage.setItem('UserKockpitRole', userResult.UserRole.filter(x => x.ACCESS_ROLE == this.sharedService.UserKockpitRole)[0].ACCESS_ROLE);

          }
          else {
            sessionStorage.setItem('UserKockpitRole', '');
          }
          if (userResult.UserRole.filter(x => x.ACCESS_ROLE == 'CFO').length > 0) {
            sessionStorage.setItem('UserCFORole', userResult.UserRole.filter(x => x.ACCESS_ROLE == this.sharedService.UserCFORole)[0].ACCESS_ROLE);
          }
          else {
            sessionStorage.setItem('UserCFORole', '');
          }

          // ✅ GUEST ADMIN ROLE CHECK
          const isGuestAdmin = userResult.UserRole.some(x => x.ACCESS_ROLE === 'GUEST ADMIN' && x.ACTIVE);
          userResult.IsGuestAdmin = isGuestAdmin; // add this property
          sessionStorage.setItem('IsGuestAdmin', isGuestAdmin.toString());

          // Update sharedService
          this.sharedService.setUserData(userResult);

          sessionStorage.setItem('Reportees', userResult.Reportees);
          sessionStorage.setItem("LoginFlag", "1");
          userResult.LoginFlag = 1;
          userResult.CompanyName = "TCPL";
          this.sharedService.setUserData(userResult);
          this.sharedService.UserId = sessionStorage.getItem("userId");
          this.authService.markSessionActive();
          //  location.href="ecr"; 
          this.route.queryParams.subscribe(params => {
            if (userResult.companyId === 'THR') {
              this._router.navigate(['/ecr']);
              return;
            }
            if (params['RequestUniqueId'] && params['RequesterTMC']) {
              this._router.navigate(['/traveldesk/TraveldeskStatus'],
                {
                  queryParams: {
                    RequestUniqueId: params['RequestUniqueId'],
                    RequesterTMC: params['RequesterTMC']
                  }
                }
              );
            }
            else if (params['ClaimId'] && params['Id']) {
              this._router.navigate(['/driverclaimview'],
                {
                  queryParams: {
                    ClaimId: params['ClaimId'],
                    Id: params['Id']
                  }
                }
              );
            }
            else {
              this._router.navigate(['/dashboard']);
            }


          });

        }
        else {
          this.btnName = "Sign In";
          this.mType = 'error';
          this.message = udata.Message;
        }
        // }
        // else {
        //   this.mType='error';
        //   this.btnName="submit";
        //   this.message="User does not exist.";                
        // }
      },
      error => {
        console.log(error);
        this.btnName = "Sign In";
      }

    );
  }

  getOtp() {
    this.btnGetOtp = "please wait...";
    let formdata = new FormData();
    formdata.append("uname", this.user.Email);
    this.crudservice.post('ecr/getOTP', formdata).subscribe((x: any) => {
      this.btnGetOtp = "Get OTP";
      if (x.Status) {
        this.showVerify = false;
        this.sharedService.SwalSuccessMsg(x.Message);
      } else {
        alert(x.Message);
      }
    },
      error => {
        console.log(error);
      }
    )
  }

  verifyOTP() {
    this.otp = this.otp0 + this.otp1 + this.otp2 + this.otp3 + this.otp4 + this.otp5;
    if (this.sharedService.checkProperty(this.otp0)) {
      this.sharedService.SwalErrorMsg('Please Enter OTP');
      return;
    }
    let fd = new FormData();
    fd.append("OTP", this.otp);
    this.crudservice.post('ecr/ValidateOTP', fd).subscribe((x: any) => {
      if (x.Status) {
        var res = x.Data;
        window.sessionStorage.setItem('userIdTHR', x.Data.THR_TMC);
        window.localStorage.setItem('userIdTHR', x.Data.THR_TMC);
        window.sessionStorage.setItem('FullNameTHR', x.Data.THR_EMPLOYEE_NAME);
        window.localStorage.setItem('FullNameTHR', x.Data.THR_EMPLOYEE_NAME);
        window.localStorage.setItem('UserEmailTHR', x.Data.THR_EMAIL_ID);
        window.sessionStorage.setItem('UserEmailTHR', x.Data.THR_EMAIL_ID);
        window.sessionStorage.setItem('UserDesignation', x.Data.THR_DESIGNATION);
        window.sessionStorage.setItem('UserDepartment', x.Data.THR_DEPARTMENT);
        window.sessionStorage.setItem('ReportingManagerName', x.Data.Reporting_Head_Name);
        window.sessionStorage.setItem('ReportingManagerEmail', x.Data.Reporting_Head_Email);
        window.sessionStorage.setItem('CompanyName', "THR");
        window.sessionStorage.setItem("LoginFlag", "2");
        res.LoginFlag = 2;
        res.CompanyName = "THR";
        this.sharedService.setUserDataTHR(res);
        this.sharedService.UserId = sessionStorage.getItem("userId");
        this.cdr.detectChanges();
        this._router.navigate(['/ecr']);
      }
      else {
        this.sharedService.SwalErrorMsg(x.Message);
      }
    },
      error => {
        console.log(error);
        this.sharedService.SwalErrorMsg("Please enter correct OTP");
      }
    )
  }

  validateDomain() {
    if (!this.ValidateEmail()) {
      return;
    }
    this.btnGetOtp = "please wait...";
    let formdata = new FormData();
    formdata.append("uname", this.user.Email);
    this.crudservice.post('ecr/ValidateDomain', formdata).subscribe((response: any) => {
      this.btnGetOtp = "Get OTP";
      if (response.Status) {
        this.getOtp();
      } else {
        alert(response.Message);
        this.btnGetOtp = "Get OTP";
      }
    },
      error => {
        console.log(error);
        this.btnGetOtp = "send otp";
      }
    )
  }

  change(e) {
    $(function () {
      var charLimit = 1;
      $(".rounded").keydown(function (e) {

        var keys = [8, 9, /*16, 17, 18,*/ 19, 20, 27, 33, 34, 35, 36, 37, 38, 39, 40, 45, 46, 144, 145];

        if (e.which == 8 && this.value.length == 0) {
          $(this).prev('.rounded').focus();
        } else if ($.inArray(e.which, keys) >= 0) {
          return true;
        } else if (this.value.length >= charLimit) {
          $(this).next('.rounded').focus();
          return false;
        } else if (e.shiftKey || e.which <= 47 || e.which >= 58) {
          return false;
        }
      }).keyup(function () {
        if (this.value.length >= charLimit) {
          $(this).next('.rounded').focus();
          return false;
        }
      });
    });
  }

  ValidateEmail() {
    var regularExpression = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
    var valid = regularExpression.test(this.user.Email) //match a letter _and_ a number
    if (!valid) {
      this.sharedService.SwalErrorMsg("Please enter valid Email Id");
      return false;
    }
    else {
      return true;
    }
  }

  togglePasswordFieldType() {
    this.isTextFieldType = !this.isTextFieldType;
  }

}
